import React, { useContext } from 'react'
import * as Component from './Marker.styles'
import PropTypes from 'prop-types'
import { Link } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useSelector } from 'react-redux'
import { entryPointId } from 'settings/app/constants'
import { htmlDecode } from 'settings/app/helpers'

const Marker = (props) => {
  const textContext = useContext(TextContext)
  const {
    id,
    active,
    title,
    street,
    zip,
    city,
    phone,
    detailUrl,
    showInfoBox,
    handleMarkerClick,
    handleMarkerHover,
    handleCloseButton,
    showAlphanumericMarker,
    isPharmacy,
    ...other
  } = props
  const [onClickHappened, setOnClickHappened] = React.useState(false)

  const entryPoint = useSelector((state) => state.application.entryPoint)
  const renderDetailLink = !(
    entryPointId.ONCALLSERVICES === entryPoint ||
    entryPointId.AMBULANCES === entryPoint
  )

  const onClick = () => {
    setOnClickHappened(true)
    handleMarkerClick()
  }

  const onHover = (bool) => {
    if (!onClickHappened) handleMarkerHover(bool)
    setOnClickHappened(false)
  }

  return (
    <Component.Root
      id={ id }
      active={ active }
      showInfoBox={ showInfoBox }
      onClick={ onClick }
      onMouseEnter={ () => onHover(true) }
      onMouseLeave={ () => onHover(false) }
      data-cy='marker'
      data-cy-marker-type={ isPharmacy ? 'pharmacy-marker' : 'default-marker' }
      className={ isPharmacy ? 'pharmacy-marker' : 'default-marker' }
      { ...other }>
      {showAlphanumericMarker && (
        <div>
          {(parseInt(id.replace('marker-', ''), 10) + 1 + 9)
            .toString(36)
            .toUpperCase()}
        </div>
      )}
      {(isPharmacy || !showAlphanumericMarker) && (
        <Component.MarkerIcon
          className={ isPharmacy ? 'icon-l-plus' : 'icon-f-map-marker' }
          active={ active }
          showInfoBox={ showInfoBox }
        />
      )}
      {showInfoBox && (
        <Component.InfoBox
          id='marker-info-box'
          data-cy='marker-info-box'
          onClick={ (e) => e.stopPropagation() }>
          <Component.InfoBoxCloseIcon
            id='marker-info-box-close-btn'
            data-cy='marker-info-box-close-btn'
            className='icon-f-cross'
            onClick={ handleCloseButton }
          />
          <Component.InfoBoxTitle data-cy='title'>
            {htmlDecode(title)}
          </Component.InfoBoxTitle>
          <Component.InfoBoxRow data-cy='address'>
            <Component.StyledIcon className='icon-f-home' />
            <span data-cy='address'>
              {street}, {zip} {city}
            </span>
          </Component.InfoBoxRow>
          {phone && (
            <Component.InfoBoxRow data-cy='phone'>
              <Component.StyledIcon className='icon-f-phone-handset' /> {phone}
            </Component.InfoBoxRow>
          )}
          {renderDetailLink && (
            <Component.InfoBoxRow justifyContent='flex-end'>
              {detailUrl && (
                <Link
                  id='map-detail-link'
                  to={ detailUrl }
                  className='more-link'
                  data-cy='map-detail-link'>
                  {textContext['general.showDetailView']}{' '}
                </Link>
              )}
            </Component.InfoBoxRow>
          )}
          <Component.InfoBoxArrow />
        </Component.InfoBox>
      )}
    </Component.Root>
  )
}

export default Marker

Marker.default = {
  markerIcon: false,
  showAlphanumericMarker: false,
}

Marker.propTypes = {
  /** alternative marker component **/
  markerIcon: PropTypes.oneOf([PropTypes.node, PropTypes.bool]),
  /** render alphanumeric icons instead of map icon **/
  showAlphanumericMarker: PropTypes.bool,
  /** **/
  id: PropTypes.string,
}
